import Connection from './connection'
import PaginatedStore from './paginated_store'

export default class Hotsheets extends PaginatedStore {
  constructor(scope) {
    super(new Connection('hotsheets', scope))
  }
}



// WEBPACK FOOTER //
// client/stores/hotsheets.js